module.exports = __webpack_public_path__ + "static/media/mountain-view.49be7396.jpg";